import { render, staticRenderFns } from "./Festivals.vue?vue&type=template&id=3bf76a90&"
import script from "./Festivals.vue?vue&type=script&lang=js&"
export * from "./Festivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports